export default {
  QUERY_ABOUT: {
    url: '/api/v1/about',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  PUT_ABOUT: {
    url: '/api/v1/admin/about',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_ABOUT_ADVANTAGES: {
    url: '/api/v1/admin/about/advantages',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_ABOUT_ADVANTAGES: {
    url: '/api/v1/admin/about/advantages',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  PUT_ABOUT_IMAGES: {
    url: '/api/v1/admin/about/image',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  }
}
